module.exports = __webpack_public_path__ + "static/media/alarm-exclamation.1333d12f.svg";